import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Image } from 'react-bootstrap';
import logoEcuador from '../assets/img/LogoEcuador.jpg';
import LogoBrasil from '../assets/img/LogoBrasil.png';
import logoUSA from '../assets/img/logoUSA.png';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const languages = [
    { code: 'es', name: 'Español', flag: logoEcuador, label: 'ES' },
    { code: 'en', name: 'English', flag: logoUSA, label: 'EN' },
    { code: 'pt', name: 'Português', flag: LogoBrasil, label: 'PT' }
  ];

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('i18nextLng', langCode);
  };

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  return (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="outline-secondary"
        size="sm"
        id="dropdown-language"
        className="language-dropdown-toggle d-flex align-items-center gap-2"
        style={{
          backgroundColor: 'transparent',
          border: '1px solid #ddd',
          borderRadius: '20px',
          padding: '4px 12px'
        }}
      >
        <Image
          src={currentLang.flag}
          alt={currentLang.name}
          style={{ width: '20px', height: '20px', objectFit: 'cover', borderRadius: '50%' }}
        />
        <span className="d-none d-sm-inline">{currentLang.label}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {languages.map((lang) => (
          <Dropdown.Item
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            active={currentLanguage === lang.code}
            className="d-flex align-items-center gap-2"
          >
            <Image
              src={lang.flag}
              alt={lang.name}
              style={{ width: '20px', height: '20px', objectFit: 'cover', borderRadius: '50%' }}
            />
            <span>{lang.name}</span>
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSelector;